import { render, staticRenderFns } from "./repay-plan.vue?vue&type=template&id=1512f208&scoped=true&"
import script from "./repay-plan.vue?vue&type=script&lang=js&"
export * from "./repay-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512f208",
  null
  
)

export default component.exports